import { APP_URLS } from 'constants/urls';
import { BreadCrumbsOptions } from './types';
import getDashboardHomeItem from './dashboardHomeItem';

export default function getTeamsBreadcrumbMap({
  pathname,
  t,
  entity,
}: BreadCrumbsOptions) {
  const dashboardHomeItem = getDashboardHomeItem({ t });
  const teamsItem = {
    label: t('teams'),
    path: APP_URLS.dashboard.teams.index.getPathWithQuery(),
  };
  const viewTeamItem = {
    label: t('team-details'),
    path: APP_URLS.dashboard.teams.view.getDynamicPath({
      pathParts: {
        id: `${entity?.id}`,
      },
    }),
  };

  return [
    {
      condition: APP_URLS.dashboard.teams.index.isTheSameUrlAs(pathname),
      data: [
        dashboardHomeItem,
        {
          label: t('teams'),
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.teams.add.isTheSameUrlAs(pathname),
      data: [
        dashboardHomeItem,
        teamsItem,
        {
          label: t('create-team'),
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.teams.edit.isTheSameUrlAs(pathname, {
        pathParts: {
          id: `${entity?.id}`,
        },
      }),
      data: [
        dashboardHomeItem,
        teamsItem,
        {
          label: t('edit-team'),
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.teams.view.isTheSameUrlAs(pathname, {
        pathParts: {
          id: `${entity?.id}`,
        },
      }),
      data: [
        dashboardHomeItem,
        teamsItem,
        {
          label: `${entity?.name || t('view-team')}`,
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.teams.members.isTheSameUrlAs(pathname, {
        pathParts: {
          id: `${entity?.id}`,
        },
      }),
      data: [
        dashboardHomeItem,
        teamsItem,
        {
          ...viewTeamItem,
          label: `${entity?.name || viewTeamItem.label}`,
        },
        {
          label: t('team-members'),
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.teams.departments.isTheSameUrlAs(pathname, {
        pathParts: {
          id: `${entity?.id}`,
        },
      }),
      data: [
        dashboardHomeItem,
        teamsItem,
        {
          ...viewTeamItem,
          label: `${entity?.name || viewTeamItem.label}`,
        },
        {
          label: t('departments'),
        },
      ],
    },
  ];
}
